<template>
    <component :is="template">
        <div>
            <div class="tit-wrap tit-wrap--unberline" v-if="detect == 'pc'">
                <h2 class="tit">마진통계</h2>
            </div>

            <v-divider class="d-md-none" />

            <v-card elevation="0" style="overflow:visible">
                <v-card-text :class="{ 'pa-0': detect == 'pc' }">
                    <div class="mb-4">
                        <cash-margin-list-filter />
                    </div>

                    <div class="mb-4" v-if="showsDescendants">
                        <cash-margin-list-member class="ml-auto mr-0" style="max-width:260px" />
                    </div>

                    <div>
                        <v-data-table
                            v-bind="{
                                items,
                                headers,
                            }"
                            hide-default-footer
                            disable-pagination
                            disable-sort
                        >
                            <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value, item)" /> </template>
                        </v-data-table>
                    </div>

                    <div class="mt-30px mt-md-40px">
                        <v-pagination
                            v-bind="{
                                value: page,
                                length: pageCount,
                                'total-visible': 11,
                            }"
                            @input="(page) => $router.push({ query: { ...$route.query, page } })"
                        />
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <common-loader v-bind="{ loading }" />
    </component>
</template>
<script>
import { mapState } from "vuex";

import api from "@/api";
import detect from "@/plugins/detect";
import { initDataTableHeaders } from "@/assets/lib";

import MypageDashboardHead from "@/components/client/mypage/dashboard/mypage-dashboard-head.vue";
import CommonLoader from "@/components/common/common-loader.vue";
import CashMarginListFilter from "@/components/client/mypage/cash-margin/cash-margin-list-filter.vue";
import CashMarginListMember from "@/components/client/mypage/cash-margin/cash-margin-list-member.vue";
import CashMarginListType from "@/components/client/mypage/cash-margin/cash-margin-list-type.vue";

export default {
    components: {
        MypageDashboardHead,
        CommonLoader,
        CashMarginListFilter,
        CashMarginListMember,
        CashMarginListType,
    },
    data: () => ({
        margins: [],
        summary: { totalCount: 0 },

        limit: 10,
        detect,

        loading: false,
    }),
    computed: {
        ...mapState({
            showsDescendants: (store) => store.user?.showsDescendantsMarginCash,
        }),

        template() {
            switch (detect) {
                case "pc": {
                    return () => import(`@/templates/${this.$theme.pages.mypage}`);
                }

                case "mobile": {
                    return () => import(`@/templates/${this.$theme.pages.default}`);
                }
            }
        },

        headers() {
            return initDataTableHeaders([
                {
                    text: "일시",
                    value: "createdAt",
                    align: "center",
                    width: 120,
                    formatter: (_, item) => `${item?._id?.y}-${item?._id?.m?.toString?.()?.padStart?.(2, "0")}-${item?._id?.d?.toString?.()?.padStart?.(2, "0")}`,
                },
                {
                    text: "선물금액",
                    value: "giftSales",
                    align: "center",
                    formatterType: "number",
                    formatterSuffix: "원",
                },
                {
                    text: "선물횟수",
                    value: "giftCount",
                    align: "center",
                    formatterType: "number",
                    formatterSuffix: "건",
                },
                {
                    text: "선물마진",
                    value: "giftValue",
                    align: "center",
                    formatterType: "number",
                    formatterSuffix: "원",
                },
                {
                    text: "전환금액",
                    value: "convSales",
                    align: "center",
                    formatterType: "number",
                    formatterSuffix: "원",
                },
                {
                    text: "전환횟수",
                    value: "convCount",
                    align: "center",
                    formatterType: "number",
                    formatterSuffix: "건",
                },
                {
                    text: "전환마진",
                    value: "convValue",
                    align: "center",
                    formatterType: "number",
                    formatterSuffix: "원",
                },
            ]);
        },

        items() {
            return [...this.margins];
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            query.type = "마진";

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                let { summary, margins } = await api.v1.me.cashes.gets({
                    headers: {
                        mode: "margin:DAILY",
                        skip,
                        limit,
                    },
                    params,
                });

                this.margins = margins;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .line-height-1-3 {
    line-height: 1.3 !important;
}
::v-deep .line-height-1-5 {
    line-height: 1.5 !important;
}
::v-deep .white-space-pre-line {
    white-space: pre-line;
}
</style>
